import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/GuestMaster.css";
import function1 from "../../assets/images/function1.svg";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  addAttendees,
  updateAttendees,
  getAllAttendees,
  deleteAttendees,
} from "../../server/Api";
import { getMainGuestByEventId } from "../../utils/getMainGuest";
import Select from "react-select";
import { getLookupUtils } from "../../utils/lookup";
import toast from "react-hot-toast";
import axios from "axios";
import { canEditPage, canDeletePage } from "../../utils/pagePermissions";
import {
  validateRequiredFields,
  firstErrorMessage,
  focusFirstInvalidField,
  withInvalidClass,
} from "../../utils/formValidation";
import { getAuthToken } from "../../utils/authToken";
import {
  eventPeopleCapacityMessage,
  capacityApiMessage,
  sumOccasionCapacities,
} from "../../utils/capacityLimits";
import { useEventCapacity } from "../../utils/useEventCapacity";
import CapacityNoticeModal from "../../components/CapacityNoticeModal";
import { getAllOccasions } from "../../utils/getAllOccasions";

const GuestAttendee = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeStep, setActiveStep] = useState(1);
  const [attendees, setAttendees] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [guests, setGuests] = useState([]);
  const [prefixDropdown, setPrefixDropdown] = useState([]);
  const [suffixDropdown, setSuffixDropdown] = useState([]);
  const [demographicDropdown, setDemographicDropdown] = useState([]);
  const [relationDropdown, setRelationDropdown] = useState([]);
  const [foodPreference, setFoodPreference] = useState([]);
  const [activeTab, setActiveTab] = useState("attendeeList");
  const [editingAttendeeId, setEditingAttendeeId] = useState(null);
  const [mainGuestId, setMainGuestId] = useState("");

  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const location = useLocation();
  const navMainGuestId = location.state?.mainGuestId;
  const selectedEvent = useSelector((state) => state.auth.selectedEvent);
  const eventEntity = useSelector((state) => state.auth.user);
  const canEdit = canEditPage(selectedEvent, "guest-attendee", eventEntity);
  const canDelete = canDeletePage(selectedEvent, "guest-attendee", eventEntity);
  const [capacityNotice, setCapacityNotice] = useState(null);
  const { eventCapacity } = useEventCapacity(selectedEvent?.eventId);
  const [occasions, setOccasions] = useState([]);
  const peopleTotal = (guests?.length || 0) + (attendees?.length || 0);
  const combinedOccasionCapacity = sumOccasionCapacities(occasions);
  const peopleCapCandidates = [
    eventCapacity,
    combinedOccasionCapacity > 0 ? combinedOccasionCapacity : null,
  ].filter((value) => value != null);
  const peopleCap = peopleCapCandidates.length
    ? Math.min(...peopleCapCandidates)
    : null;

  const initialAttendeeData = {
  eventId: "",
  mainGuestId: "",
  relationWithMainMember: "",
  prefix: "",
  firstName: "",
  middleName: "",
  lastName: "",
  suffix: "",
  gender: "",
  email: "",
  mobileNo: "",
  foodPreference: "",
  demographic: "", 
  allergic: "",
  specialNeeds: "",
  specialRequest: "",
  enteredBy: "",
};

const [attendeeData, setAttendeeData] = useState(initialAttendeeData);




  const [deleteConfirmation, setDeleteConfirmation] = useState({
    isOpen: false,
    attendeeId: null,
    mainGuestId: null, // 👈 Must be included
    guestName: "",
  });

  const guestOptions = Array.isArray(guests)
    ? guests.map((attendee) => ({
        value: attendee._id,
        label: `${attendee.prefix} ${attendee.firstName} ${
          attendee.MiddleName
        } ${attendee.lastName} ${attendee.suffix || ""} `
          .replace(/\s+/g, " ")
          .trim(),
      }))
    : [];

  const getAllAttendeeByEventId = async () => {
    try {
      if (!selectedEvent?.eventId) return;

      const url = getAllAttendees(selectedEvent.eventId); // this returns the URL
      const response = await fetch(url, {
        headers: {
          ...(getAuthToken()
            ? { Authorization: `Bearer ${getAuthToken()}` }
            : {}),
        },
      });
      const data = await response.json();

      setAttendees(data.data || []);
      console.log("Attendee fetched successfully:", data);
    } catch (error) {
      console.error("Error fetching attendees:", error);
      toast.error("Failed to fetch attendees.");
    }
  };

  const getAllGuestByEventId = async () => {
    try {
      if (!selectedEvent?.eventId) return;

      const guestsData = await getMainGuestByEventId(selectedEvent.eventId); // use the utility
      setGuests(guestsData);
      console.log("Guests fetched successfully:", guestsData);
    } catch (error) {
      console.error("Error fetching guests:", error);
      toast.error("Failed to fetch guests.");
    }
  };

  useEffect(() => {
    if (selectedEvent?.eventId) {
      getAllGuestByEventId();
      getAllOccasions(selectedEvent.eventId)
        .then(setOccasions)
        .catch(() => setOccasions([]));
    }
  }, [selectedEvent?.eventId]);

  useEffect(() => {
    if (selectedEvent?.eventId) {
      getAllAttendeeByEventId();
    }
  }, [selectedEvent?.eventId]);

  useEffect(() => {
    if (activeTab === "attendeeList" && selectedEvent?.eventId) {
      getAllAttendeeByEventId();
    }
  }, [activeTab, selectedEvent?.eventId]);

  const handleAddEventClick = () => {
    setIsSidebarExpanded((prev) => !prev);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAttendeeData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (fieldErrors[name]) {
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }
  };

const handleCancel = () => {
  setAttendeeData(initialAttendeeData);
  setMainGuestId("");
  setIsEditing(false);
  setFieldErrors({});
};


  const handleSubmit = async (e) => {
  e.preventDefault();

  const errors = validateRequiredFields([
    { key: "mainGuestId", value: mainGuestId, label: "Main Guest" },
    {
      key: "relationWithMainMember",
      value: attendeeData.relationWithMainMember,
      label: "Relation with Main Member",
    },
    { key: "prefix", value: attendeeData.prefix, label: "Prefix" },
    { key: "firstName", value: attendeeData.firstName, label: "First Name" },
    { key: "middleName", value: attendeeData.middleName, label: "Middle Name" },
    { key: "lastName", value: attendeeData.lastName, label: "Last Name" },
    { key: "suffix", value: attendeeData.suffix, label: "Suffix" },
    { key: "mobileNo", value: attendeeData.mobileNo, label: "Mobile Number" },
    { key: "email", value: attendeeData.email, label: "Email" },
  ]);

  if (
    attendeeData.email &&
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(attendeeData.email).trim())
  ) {
    errors.email = "Enter a valid email address";
  }

  if (Object.keys(errors).length > 0) {
    setActiveStep(1);
    setFieldErrors(errors);
    toast.error(firstErrorMessage(errors));
    focusFirstInvalidField(errors, {
      rootSelector: "#attendeeForm",
      order: [
        "mainGuestId",
        "relationWithMainMember",
        "prefix",
        "firstName",
        "middleName",
        "lastName",
        "suffix",
        "mobileNo",
        "email",
      ],
    });
    return;
  }

  setFieldErrors({});

  if (!isEditing && peopleCap != null && peopleTotal + 1 > peopleCap) {
    const isOccasionLimit =
      combinedOccasionCapacity > 0 && peopleCap === combinedOccasionCapacity;
    setCapacityNotice({
      title: isOccasionLimit
        ? "Cannot exceed occasion capacity"
        : "Cannot exceed event capacity",
      message: isOccasionLimit
        ? `Guests and attendees cannot exceed the combined occasion capacity of ${combinedOccasionCapacity}. ${peopleTotal} ${
            peopleTotal === 1 ? "person is" : "people are"
          } already added.`
        : eventPeopleCapacityMessage({
            eventCapacity: peopleCap,
            currentTotal: peopleTotal,
            adding: 1,
          }),
    });
    return;
  }

  try {
    const formDataToSend = {
      ...attendeeData,
      eventId: selectedEvent?.eventId || "",
      mainGuestId: mainGuestId || "",
      relationWithMainMember: attendeeData.relationWithMainMember || "",
      enteredBy: eventEntity.name || "anonymousUser",
      demographic: attendeeData.demographic || "", // 🔹 Added here
    };

    const url = isEditing
      ? updateAttendees(editingAttendeeId)
      : addAttendees();

    const method = isEditing ? "put" : "post";

    const response = await axios({
      method,
      url,
      headers: {
        "Content-Type": "application/json",
      },
      data: formDataToSend,
    });

    if (response.status === 200 || response.status === 201) {
      toast.success(
        isEditing
          ? "Attendee updated successfully!"
          : "Attendee added successfully!"
      );
      setIsEditing(false);
      setEditingAttendeeId(null);
      setAttendeeData(attendeeData); // Reset form
      getAllAttendeeByEventId(); // Refresh guest list
    } else {
      console.error("Unexpected response:", response);
      toast.error("Failed to add/update guest.");
    }
  } catch (error) {
    console.error("Error adding/updating guest:", error);
    if (error.response?.data?.code === "CAPACITY_EXCEEDED") {
      setCapacityNotice({
        title: "Cannot exceed capacity",
        message: capacityApiMessage(error),
      });
    } else {
      toast.error("Failed to add/update guest.");
    }
  }
};


const handleEditAttendee = (guest) => {
  setIsEditing(true);
  setEditingAttendeeId(guest._id);

  setMainGuestId(guest.mainGuestId || ""); // Set mainGuestId during edit

  // Map DB demographic value to dropdown code
  const selectedDemographicOption = demographicDropdown.find(
    (item) => item.Lookup_Value_Name === guest.demographic
  );

  setAttendeeData({
    eventId: guest.eventId || "",
    mainGuestId: guest.mainGuestId || "",
    relationWithMainMember: guest.relationWithMainMember || "",
    prefix: guest.prefix || "",
    firstName: guest.firstName || "",
    middleName: guest.middleName || "",
    lastName: guest.lastName || "",
    suffix: guest.suffix || "",
    gender: guest.gender || "",
    email: guest.email || "",
    mobileNo: guest.mobileNo || "",
    foodPreference: guest.foodPreference || "",
    demographic: selectedDemographicOption
      ? selectedDemographicOption.Lookup_Value_Code
      : "", // Use mapped code for dropdown
    allergic: guest.allergic || "",
    specialNeeds: guest.specialNeeds || "",
    specialRequest: guest.specialRequest || "",
    enteredBy: eventEntity.name || "anonymousUser",
  });
};


  useEffect(() => {
    if (navMainGuestId && !isEditing) {
      setMainGuestId(navMainGuestId);
      setAttendeeData((prev) => ({
        ...prev,
        mainGuestId: navMainGuestId,
      }));
    }
  }, [navMainGuestId, isEditing]);

  const handleDelete = async () => {
    try {
      const response = await fetch(
        deleteAttendees(
          deleteConfirmation.mainGuestId,
          deleteConfirmation.attendeeId
        ),
        {
          method: "DELETE",
          headers: {
            ...(getAuthToken()
              ? { Authorization: `Bearer ${getAuthToken()}` }
              : {}),
          },
        }
      );

      if (response.ok) {
        toast.success("Guest deleted successfully!");
        setDeleteConfirmation({
          isOpen: false,
          attendeeId: null,
          guestId: null,
          guestName: "",
        });
        getAllAttendeeByEventId(); // Refresh list
      } else {
        const errorText = await response.text();
        toast.error("Failed to delete guest.");
        console.error("Delete failed:", errorText);
      }
    } catch (error) {
      console.error("Error deleting guest:", error);
      toast.error("Error deleting guest.");
    }
  };

  useEffect(() => {
    const fetchDropdownData = async (lookupId, setDropdown, errorMessage) => {
      try {
        const result = await getLookupUtils(lookupId);
        setDropdown(result.data);
      } catch (error) {
        console.error(errorMessage, error);
      }
    };
    fetchDropdownData("3", setPrefixDropdown, "Failed to fetch Prefix Data:");
    fetchDropdownData("19", setSuffixDropdown, "Failed to fetch Suffix Data:");
    fetchDropdownData("4", setRelationDropdown, "Failed to fetch Suffix Data:");
    fetchDropdownData("17", setDemographicDropdown, "Failed to fetch Suffix Data:");
    fetchDropdownData(
      "8",
      setFoodPreference,
      "Failed to fetch Food Preference Data:"
    );
  }, []);

  const getProgressWidth = () => {
    if (activeStep === 1) return "25%";
    if (activeStep === 2) return "100%";
  };

  const filteredAttendees = attendees.filter((attendee) => {
    const fullName = `${attendee.prefix || ""} ${attendee.firstName || ""} ${
      attendee.middleName || ""
    } ${attendee.lastName || ""} ${attendee.suffix || ""}${
      attendee.mainGuestName || ""
    } `
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

    return fullName.includes(searchTerm.toLowerCase().trim());
  });

  const renderFormOne = () => (
    <form id="attendeeForm">
      <div className="">
        <div className="row g-3">
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Main Guest ID/Name <span className="required-asterisk">*</span>
            </label>

            <div
              data-field="mainGuestId"
              className={
                fieldErrors.mainGuestId
                  ? "react-select-invalid field-invalid-wrap is-invalid"
                  : ""
              }
            >
              <Select
                options={guestOptions}
                value={
                  guestOptions.find((option) => option.value === mainGuestId) ||
                  null
                }
                onChange={(selectedOption) => {
                  const value = selectedOption?.value || "";
                  setMainGuestId(value);
                  setAttendeeData((prev) => ({
                    ...prev,
                    mainGuestId: value,
                  }));
                  setFieldErrors((prev) => {
                    if (!prev.mainGuestId) return prev;
                    const next = { ...prev };
                    delete next.mainGuestId;
                    return next;
                  });
                }}
                placeholder="Select Main Guest"
              />
            </div>
            {fieldErrors.mainGuestId ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.mainGuestId}
              </div>
            ) : null}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Relation with Main Member{" "}
              <span className="required-asterisk">*</span>
            </label>
            <select
              className={withInvalidClass(
                "form-select",
                !!fieldErrors.relationWithMainMember
              )}
              name="relationWithMainMember"
              value={attendeeData.relationWithMainMember}
              onChange={handleInputChange}
            >
              <option value="">Select relation with main member</option>
              {relationDropdown.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
            {fieldErrors.relationWithMainMember ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.relationWithMainMember}
              </div>
            ) : null}
          </div>

<div className="col-md-6 mb-3">
  <label className="form-label">Demographic</label>
  <select
    className="form-select"
    name="demographic"
    value={attendeeData.demographic || ""}
    onChange={handleInputChange}
  >
    <option value="">Select Demographic</option>
    {demographicDropdown.map((item) => (
      <option key={item._id} value={item.Lookup_Value_Code}>
        {item.Lookup_Value_Name}
      </option>
    ))}
  </select>
</div>



          <div className="col-md-6 mb-3">
            <label className="form-label">
              Prefix <span className="required-asterisk">*</span>
            </label>
            <select
              className={withInvalidClass("form-select", !!fieldErrors.prefix)}
              name="prefix"
              value={attendeeData.prefix}
              onChange={handleInputChange}
            >
              <option value="">Select Prefix</option>
              {prefixDropdown.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
            {fieldErrors.prefix ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.prefix}
              </div>
            ) : null}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">
              First Name <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={withInvalidClass(
                "form-control",
                !!fieldErrors.firstName
              )}
              name="firstName"
              placeholder="Enter First Name"
              value={attendeeData.firstName}
              onChange={handleInputChange}
            />
            {fieldErrors.firstName ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.firstName}
              </div>
            ) : null}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Middle Name <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={withInvalidClass(
                "form-control",
                !!fieldErrors.middleName
              )}
              name="middleName"
              placeholder="Middle name"
              value={attendeeData.middleName}
              onChange={handleInputChange}
            />
            {fieldErrors.middleName ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.middleName}
              </div>
            ) : null}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Last Name <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={withInvalidClass(
                "form-control",
                !!fieldErrors.lastName
              )}
              name="lastName"
              placeholder="Enter Last Name"
              value={attendeeData.lastName}
              onChange={handleInputChange}
            />
            {fieldErrors.lastName ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.lastName}
              </div>
            ) : null}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Suffix <span className="required-asterisk">*</span>
            </label>
            <select
              className={withInvalidClass("form-select", !!fieldErrors.suffix)}
              name="suffix"
              placeholder="Enter Suffix"
              value={attendeeData.suffix}
              onChange={handleInputChange}
            >
              <option value="">Select Suffix</option>
              {suffixDropdown.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
            {fieldErrors.suffix ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.suffix}
              </div>
            ) : null}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Gender</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                value="Male"
                checked={attendeeData.gender === "Male"}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="male">
                Male
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                value="Female"
                checked={attendeeData.gender === "Female"}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="female">
                Female
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                value="Other"
                checked={attendeeData.gender === "Other"}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="other">
                Other
              </label>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Mobile No. <span className="required-asterisk">*</span>
            </label>
            <input
              type="tel"
              className={withInvalidClass(
                "form-control",
                !!fieldErrors.mobileNo
              )}
              name="mobileNo"
              placeholder="Enter mobile number"
              value={attendeeData.mobileNo}
              onChange={handleInputChange}
            />
            {fieldErrors.mobileNo ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.mobileNo}
              </div>
            ) : null}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Email <span className="required-asterisk">*</span>
            </label>
            <input
              type="email"
              className={withInvalidClass("form-control", !!fieldErrors.email)}
              name="email"
              placeholder="Enter Email Id"
              value={attendeeData.email}
              onChange={handleInputChange}
            />
            {fieldErrors.email ? (
              <div className="invalid-feedback d-block">
                {fieldErrors.email}
              </div>
            ) : null}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Food Preference</label>
            <select
              className="form-select"
              name="foodPreference"
              value={attendeeData.foodPreference}
              onChange={handleInputChange}
            >
              <option value="">Select Food Preference</option>
              {foodPreference.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Allergic</label>
            <input
              type="text"
              className="form-control"
              name="allergic"
              placeholder="Enter allergic details"
              value={attendeeData.allergic}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Special Needs</label>
            <textarea
              className="form-control"
              name="specialNeeds"
              placeholder="Enter allergy details if any"
              value={attendeeData.specialNeeds}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Special Request</label>
            <textarea
              className="form-control"
              name="specialRequest"
              placeholder="Enter special request if any"
              value={attendeeData.specialRequest}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>
      {/* <hr />
        <div className="mt-4 d-flex justify-content-end gap-2 justify-content-center py-3">
            <button type="submit" className="btn btn-success btn-save">Save</button>
            <button type="reset" className="btn btn-outline-secondary btn-cancel">Cancel</button>
        </div> */}
    </form>
  );

  const renderFormTwo = () => {
    const renderTabContent = () => {
      switch (activeTab) {
        case "arrival":
          return (
            <div className="row mt-3">
              <div className="col-md-6 mb-3">
                <label htmlFor="arrivaldate" className="form-label">
                  Arrival Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="arrivaldate"
                  placeholder="Select arrival date"
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="arrivaltime" className="form-label">
                  Arrival Time
                </label>
                <input
                  type="time"
                  className="form-control"
                  id="arrivaltime"
                  placeholder="Select arrival time"
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Flight No. /Train No./Bus No.
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter flight/train/bus no."
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">PNR No.</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter PNR no."
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Pick Up Location</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter pick up location"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Mode Of Travel</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter mode of travel"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Bags</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter no. of bags"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">No. Of Tags</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter no. of tags"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Tag Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter tag name"
                  required
                />
              </div>
            </div>
          );
        case "travel":
          return (
            <div className="row mt-3">
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Flight No. /Train No./Bus No.
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter flight/train/bus no."
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">PNR No.</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter PNR no."
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Drop Location</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter drop location"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Mode Of Travel</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter mode of travel"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Bags</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter no. of bags"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">No. Of Tags</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter no. of tags"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Tag Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter tag name"
                  required
                />
              </div>
            </div>
          );
        default:
          return null;
      }
    };

    return (
      <div>
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "arrival" ? "active" : ""}`}
              onClick={() => setActiveTab("arrival")}
            >
              Arrival
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "travel" ? "active" : ""}`}
              onClick={() => setActiveTab("travel")}
            >
              Departure
            </button>
          </li>
        </ul>

        <div className="tab-content p-3">{renderTabContent()}</div>
      </div>
    );
  };

  const getStepContent = (step) => {
    switch (step) {
      case 1:
        return (
          <>
            {/* <h5>Add Main Guest</h5> */}
            {renderFormOne()}
          </>
        );
      case 2:
        return (
          <>
            {/* <h5>Travel Details</h5> */}
            {renderFormTwo()}
          </>
        );
      default:
        return <div>Invalid Step</div>;
    }
  };

  const shouldExpand =
    !canEdit ? !isSidebarExpanded : isSidebarExpanded;

  return (
    <>
      <div className="container-fluid GuestAttendee">
        <div className="">
          <div
            className={`occasion-top occasion-top-with-sidebar row g-4 align-items-center${
              isSidebarExpanded ? " expanded-sidebar" : ""
            }${
              !canEdit
                ? " expanded-sidebar-role-viewer"
                : ""
            }`}
          >
            <div className="col-lg-9">
              <h2 className="mb-0">Guest Attendee</h2>
            </div>
            <div className="col-lg-3 occasion-top-search-col">
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Search Attendee..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div
          className={`row g-4 
    ${isSidebarExpanded ? "expanded-sidebar" : ""} 
    ${!canEdit ? "expanded-sidebar-role-viewer" : ""}`}
        >
          {canEdit && (
            <div className="col-lg-9" id="formColumn">
              <div className="form-section">
                <div className="all-page-scroll vh71">
                  <div className="progress-container position-relative mb-3">
                    <div className="progress-line">
                      <div
                        className="progress-fill"
                        style={{ width: getProgressWidth() }}
                      ></div>
                    </div>

                    <div className="d-flex justify-content-between">
                      {[1, 2].map((step) => (
                        <div
                          key={step}
                          className={`step text-center ${
                            activeStep >= step ? "active" : ""
                          }`}
                          onClick={() => setActiveStep(step)}
                        >
                          <div className="circle">{step}</div>
                          <div className="label">
                            {step === 1 ? "Add Attendee" : "Travel Details"}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="step-content">
                    {getStepContent(activeStep)}
                  </div>
                </div>
                <hr />
                <div className="d-flex justify-content-end gap-2 justify-content-center py-2">
                  <button
                    type="button"
                    form="guestForm"
                    className="btn btn-success btn-save"
                    onClick={handleSubmit}
                  >
                    {isEditing ? "Update" : "Save"}
                  </button>
                  <button
                    type="reset"
                    className="btn btn-outline-secondary btn-cancel"
                      onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          <div
            className="col-lg-3"
            id={
              !canEdit
                ? "sidebarColumnRoleviewer"
                : "sidebarColumn"
            }
          >
            <div className="event-sidebar">
              <div className="guest-list-toolbar">
                <h6 className="mb-0 event-inner-hed">Attendee List</h6>
                <button
                  type="button"
                  className="guest-sidebar-toggle"
                  onClick={handleAddEventClick}
                  title={isSidebarExpanded ? "Collapse list" : "Expand list"}
                  aria-label={
                    isSidebarExpanded ? "Collapse list" : "Expand list"
                  }
                >
                  <i
                    className={`bi ${
                      isSidebarExpanded ? "bi-chevron-right" : "bi-chevron-left"
                    }`}
                  ></i>
                </button>
              </div>
              <hr />
              <div className="all-page-right-scroll">
                {/* Tabs */}
                {/* <ul
                  className="nav nav-tabs mb-3"
                  id="guestsTabs"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="attendeeList-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#attendeeList"
                      type="button"
                      role="tab"
                    >
                      Attendee List
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="attendee-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#attendee"
                      type="button"
                      role="tab"
                    >
                      Attendee List
                    </button>
                  </li>
                </ul> */}
                <div className="tab-content" id="eventTabsContent">
                  {/* Guest Tab */}
                  <div
                    className={`tab-pane fade ${
                      activeTab === "attendeeList" ? "show active" : ""
                    }`}
                    id="attendeeList"
                  >
                    {shouldExpand ? (
                      <>
                        {" "}
                        <div className="">
                          <div className="table-responsive">
                            <table className="table">
                              <thead className="thead-dark table-bordered table-hover table-bg-new">
                                <tr>
                                  <th>#</th>
                                  <th>Attendee Name</th>
                                  <th>Main Guest Name</th>
                                  <th>Relation</th>
                                  <th>Gender</th>
                                  <th>Allergy</th>
                                  <th>Special Needs</th>
                                  <th>
                                    {canEdit && "Action"}                              
                                    </th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredAttendees.map((attendee, index) => (
                                  <tr key={attendee._id || index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {attendee.prefix} {attendee.firstName}{" "}
                                      {attendee.MiddleName} {attendee.lastName}{" "}
                                      {attendee.suffix}
                                    </td>
                                    <td>{attendee.mainGuestName}</td>
                                    <td>
                                      {attendee.relationWithMainMember || "-"}
                                    </td>
                                    <td>{attendee.gender || "-"}</td>
                                    <td>
                                      {attendee.allergic
                                        ? attendee.allergic
                                        : ""}
                                    </td>
                                    {/* <td>{attendee.allergic ? 'Allergy' : 'No Allergy'}</td> */}
                                    <td>
                                      {attendee.specialNeeds
                                        ? attendee.specialNeeds
                                        : ""}
                                    </td>
                                    <td>
                                      {canEdit && (
                                        <>
                                          <a
                                            href="#"
                                            className="text-primary edit-btn me-2"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleEditAttendee(attendee); // pass the current guest object
                                            }}
                                          >
                                            Edit
                                          </a>
                                    {canDelete && (

                                          <a
                                            href="#"
                                            className="text-danger btn-danger"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setDeleteConfirmation({
                                                isOpen: true,
                                                guestId: attendee.mainGuestId, // Add this
                                                attendeeId: attendee._id,
                                                guestName: `${
                                                  attendee.firstName
                                                } ${
                                                  attendee.MiddleName || ""
                                                } ${attendee.lastName}`,
                                              });
                                            }}
                                          >
                                            Delete
                                          </a>
                                    )}
                                        </>
                                      )}
                                      &nbsp;
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {" "}
                        <div className="list-side-stack">
                          {filteredAttendees.map((attendee, index) => (
                            <div
                              className="event-card list-side-card"
                              key={attendee._id || index}
                            >
                              <div className="list-side-card-title">
                                {[
                                  attendee.prefix,
                                  attendee.firstName,
                                  attendee.MiddleName,
                                  attendee.lastName,
                                  attendee.suffix,
                                ]
                                  .filter(Boolean)
                                  .join(" ")}
                              </div>
                              <div className="list-side-card-meta">
                                <span>
                                  <em>Guest</em>
                                  {attendee.mainGuestName || "—"}
                                </span>
                                <span>
                                  <em>Relation</em>
                                  {attendee.relationWithMainMember || "—"}
                                </span>
                                <span>
                                  <em>Gender</em>
                                  {attendee.gender || "—"}
                                </span>
                                <span>
                                  <em>Allergy</em>
                                  {attendee.allergic
                                    ? attendee.allergic
                                    : "None"}
                                </span>
                                <span>
                                  <em>Needs</em>
                                  {attendee.specialNeeds
                                    ? attendee.specialNeeds
                                    : "None"}
                                </span>
                              </div>
                              <div className="list-side-card-actions event-actions">
                                {canEdit && (
                                  <>
                                    <a
                                      href="#"
                                      className="btn edit-btn"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleEditAttendee(attendee);
                                      }}
                                    >
                                      Edit
                                    </a>
                                    {canDelete && (
                                      <a
                                        href="#"
                                        className="btn btn-danger"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setDeleteConfirmation({
                                            isOpen: true,
                                            attendeeId: attendee._id,
                                            mainGuestId: attendee.mainGuestId,
                                            guestName: `${attendee.firstName} ${
                                              attendee.MiddleName || ""
                                            } ${attendee.lastName}`,
                                          });
                                        }}
                                      >
                                        Delete
                                      </a>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>

                  {/* Attendee Tab */}
                  {/* <div className="tab-pane fade" id="attendee" role="tabpanel">
                    <div className="event-list-scroll">
                      <div class="table-responsive">
                        <table class="table">
                          <thead class="thead-dark table-bordered table-hover">
                            <tr>
                              <th>#</th>
                              <th>Firstname</th>
                              <th>Lastname</th>
                              <th>Age</th>
                              <th>City</th>
                              <th>Country</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>Anna</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>Test</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>Admin</td>
                              <td>Pitt</td>
                              <td>35</td>
                              <td>New York</td>
                              <td>USA</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <hr />
              <div className="mt-3 py-2">
                                    {/* {canEdit && (
                
                <button className="btn btn-outline-success excel-btn">
                  Export to Excel <i className="bi bi-download"></i>
                </button>
                )} */}
              </div>
            </div>
          </div>
        </div>
        {deleteConfirmation.isOpen && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() =>
                      setDeleteConfirmation({
                        isOpen: false,
                        attendeeId: null,
                        guestName: "",
                      })
                    }
                  ></button>
                </div>
                <div className="modal-body">
                  <p>
                    Are you sure you want to delete attendee:{" "}
                    <strong>{deleteConfirmation.guestName}</strong>?
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary cancel-btn"
                    onClick={() =>
                      setDeleteConfirmation({
                        isOpen: false,
                        attendeeId: null,
                        attendeeName: "",
                      })
                    }
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <CapacityNoticeModal
          open={Boolean(capacityNotice)}
          title={capacityNotice?.title}
          message={capacityNotice?.message}
          onClose={() => setCapacityNotice(null)}
        />
      </div>
    </>
  );
};

export default GuestAttendee;
